import React from 'react';
import { useBrand } from '@/context/BrandContext';
import { EditableText } from '../ui/EditableText';
import { BrandSectionLayout } from './BrandSectionLayout';

interface DefaultSectionProps {
  section: any;
  isEditing: boolean;
  isGlobalDarkMode: boolean;
  editingElement: string | null;
  setEditingElement: (element: string | null) => void;
  updateSectionContent: (key: string, value: string) => void;
  updateSectionStyles: (key: string, styles: any) => void;
  pageNumber?: number;
}

export const DefaultSection: React.FC<DefaultSectionProps> = ({
  section,
  isEditing,
  isGlobalDarkMode,
  editingElement,
  setEditingElement,
  updateSectionContent,
  updateSectionStyles,
  pageNumber = 1
}) => {
  const { dispatch, state } = useBrand();

  return (
    <BrandSectionLayout
      section={section}
      isEditing={isEditing}
      isGlobalDarkMode={isGlobalDarkMode}
      editingElement={editingElement}
      setEditingElement={setEditingElement}
      updateSectionContent={updateSectionContent}
      updateSectionStyles={updateSectionStyles}
      pageNumber={pageNumber}
    >
      <div className="flex items-center justify-center h-full">
        <EditableText
          value={section.title || 'Section'}
          onChange={(value) => {
            const updatedSection = { ...section, title: value };
            const sectionIndex = state.sections.findIndex(s => s.id === section.id);
            if (sectionIndex !== -1) {
              dispatch({
                type: 'UPDATE_SECTION',
                payload: { index: sectionIndex, section: updatedSection }
              });
            }
          }}
          element="h2"
          className="text-4xl font-bold"
          placeholder="{{brandName}} Section"
          multiline={true}
          editModeEnabled={isEditing}
          isEditing={isEditing && editingElement === 'title'}
          onEditStart={() => setEditingElement('title')}
          onEditEnd={() => setEditingElement(null)}
          isGlobalDarkMode={isGlobalDarkMode}
          sectionBackgroundColor={section.customization?.backgroundColor || section.styles.backgroundColor}
        />
      </div>
    </BrandSectionLayout>
  );
};